import { render, staticRenderFns } from "./WordCloud_su1_1.vue?vue&type=template&id=08a8a6ed&scoped=true"
import script from "./WordCloud_su1_1.vue?vue&type=script&lang=js"
export * from "./WordCloud_su1_1.vue?vue&type=script&lang=js"
import style0 from "./WordCloud_su1_1.vue?vue&type=style&index=0&id=08a8a6ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a8a6ed",
  null
  
)

export default component.exports